'use strict';

var Page = require('stb-component-page'),
    dom  = require('spa-dom'),
    keys = require('stb-keys'),

    LayoutList     = require('mag-component-layout-list'),
    Layout         = require('mag-component-layout'),
    app            = require('mag-app'),
    ModalMessage   = require('mag-component-modal'),
    ModalCheckList = require('mag-component-modal-check-list'),
    RadioList      = require('mag-component-radio-list'),

    utils = {
        initYears: require('../utils/init.years'),
        prepareMovies: require('../utils/prepare.movies'),
        toggleFavorite: require('../utils/toggle.favorite')
    },
    InfoPanel     = require('../components/info.panel'),
    Grid          = require('../components/grid'),

    page          = new Page({$node: document.getElementById('pageMovies')}),
    timers        = {},
    requestConfig = {},

    noEvents = false,

    moviesGrid, searchLayout,
    modalSelectGenre, modalSelectYear, modalSortFilm,
    filtersList, sortList, infoPanel,
    leftLayout, f3;


function getMovies ( callback, config ) {
    app.api.getList(config, function ( error, data, count ) {
        callback(error, utils.prepareMovies(data), count);
    });
}


/**
 * Change favorite state.
 */
function toggleFavorite () {
    if ( moviesGrid.$focusItem.value.favorite ) {
        infoPanel.$movie.classList.remove('inFavorite');
    } else {
        infoPanel.$movie.classList.add('inFavorite');
    }

    utils.toggleFavorite(moviesGrid.$focusItem.value);
}


infoPanel = new InfoPanel();

if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    f3 = new Layout({
        focusable: true,
        data: [
            {
                className: 'favoriteTitle add',
                value: gettext('Hold the OK button to add to Favorites')
            },
            {
                className: 'favoriteTitle remove',
                value: gettext('Hold the OK button to remove from Favorites')
            }
        ],
        className: 'favoriteBlock',
        events: {
            click: toggleFavorite
        }
    });
} else {
    f3 = new Layout({
        focusable: true,
        data: [
            {
                className: 'theme-icon theme-icon-rc-f3'
            },
            {
                className: 'favoriteTitle add',
                value: gettext('Add to favorites')
            },
            {
                className: 'favoriteTitle remove',
                value: gettext('Remove from favorites')
            }
        ],
        className: 'favoriteBlock',
        events: {
            click: toggleFavorite
        }
    });
}

infoPanel.$movie.appendChild(f3.$node);


searchLayout = new Layout({
    data: [
        dom.tag('div', {className: 'searchFocus'}, dom.tag('div', {className: 'searchIcon'})),
        {
            name: '$text',
            value: gettext('Search for movies, series and TV shows'),
            className: 'searchText noData'
        }
    ],
    className: 'searchBlock',
    events: {
        focus: function () {
            infoPanel.showInfo();
            infoPanel.$info.innerText = gettext('Find your favorite movies, series and TV shows by title or by genre');
        },
        click: function () {
            core.intent({
                action: 'keyboard',
                data: {
                    value: requestConfig.search,
                    title: gettext('Search for movies, series and TV shows')
                },
                events: {
                    done: function ( data ) {
                        requestConfig.search = data.value;
                        if ( data.value ) {
                            searchLayout.$body.classList.add('searchActive');
                            searchLayout.links.$text.innerText = data.value;
                            searchLayout.links.$text.classList.remove('noData');
                        } else {
                            searchLayout.$body.classList.remove('searchActive');
                            searchLayout.links.$text.innerText = gettext('Search for movies, series and TV shows');
                            searchLayout.links.$text.classList.add('noData');
                        }
                        moviesGrid.init({
                            getter: getMovies,
                            request: requestConfig
                        });
                    }
                }
            }, function ( error ) {
                debug.fail('Keyboard error', error);
            });
            event.stop = true;
        },
        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.down:
                    filtersList.focus();
                    event.stop = true;
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click'] ) {
                        // notify listeners
                        this.emit('click');
                    }
                    event.stop = true;
                    break;
            }
        }
    }
});


filtersList = new LayoutList({
    cycle: false,
    className: 'filtersList',

    data: [
        {
            name: 'genres',
            value: gettext('All genres'),
            data: gettext('You can choose a movie by genre or year of release. Or you can sort them using other parameters.'),
            click: function () {
                filtersList.blur();

                //fix artefacts on mag322
                setTimeout(function () {
                    modalSelectGenre.show();
                }, app.config.delay.modalShow);
            }
        },
        {
            name: 'years',
            value: gettext('All years'),
            data: gettext('You can choose a movie by genre or year of release. Or you can sort them using other parameters.'),
            click: function () {
                filtersList.blur();

                //fix artefacts on mag322
                setTimeout(function () {
                    modalSelectYear.show();
                }, app.config.delay.modalShow);
            }
        },
        {
            name: 'sort',
            value: gettext('Sort by') + ' ' + gettext('date'),
            data: gettext('You can choose a movie by genre or year of release. Or you can sort them using other parameters.'),
            click: function () {
                filtersList.blur();

                //fix artefacts on mag322
                setTimeout(function () {
                    modalSortFilm.show();
                }, app.config.delay.modalShow);

            }
        }
    ],

    render: function ( $item, config ) {
        var layout, focus, button,
            title = {};

        while ( $item.firstChild ) {
            $item.removeChild($item.firstChild);
        }
        button = dom.tag('div', {className: 'button'},
            dom.tag('div', {className: 'titleWrapper'},
                title.blured = dom.tag('div', {className: 'title'}, config.value)));
        focus = dom.tag('div', {className: 'buttonFocus'},
            dom.tag('div', {className: 'titleWrapper'},
                title.focused = dom.tag('div', {className: 'title'}, config.value)));

        while ( $item.firstChild ) {
            $item.removeChild($item.firstChild);
        }

        layout = new Layout({
            focusable: false,
            data: [button, focus]
        });

        if ( config.name ) {
            this.links[config.name] = layout;
        }

        $item.appendChild(layout.$node);
        layout.title = title;
        $item.title = title;
        layout.parent = this;
        layout.$parentItem = $item;
        $item.layout = layout;

        layout.addListener('click', function () {
            layout.parent.emit('click:item', {$item: $item, inner: true});
        });

        if ( config.click ) {
            this.handlers[$item.index] = config.click;
        }

        $item.value = config.value || {};
    },

    fixedData: true,
    size: 3,
    focusIndex: 0,
    propagate: false,
    type: LayoutList.prototype.TYPE_HORIZONTAL,
    events: {
        focus: function () {
            infoPanel.showInfo();
            searchLayout.show();
            moviesGrid.$node.classList.remove('noSearchLine');
            if ( this.$focusItem ) {
                infoPanel.$info.innerText = this.$focusItem.data.data;
            }
        },

        // blur: function () {},
        'focus:item': function ( event ) {
            infoPanel.$info.innerText = event.$curr.data.data;
        },

        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.up:
                    event.stop = true;
                    searchLayout.focus();
                    break;
                case keys.down:
                    event.stop = true;
                    searchLayout.hide();
                    moviesGrid.$node.classList.add('noSearchLine');
                    moviesGrid.focus();
                    break;
                case keys.right:
                case keys.left:
                    // cursor move only on arrow keys
                    this.move(event.code);
                    event.stop = true;
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click:item'] && this.$focusItem ) {
                        // notify listeners
                        this.emit('click:item', {$item: this.$focusItem, event: event});
                    }
                    event.stop = true;
                    break;
            }
        }
    }
});


moviesGrid = new Grid({
    getter: function () {
        return [];
    },
    sizeX: app.metrics.moviesGrid.x,
    sizeY: app.metrics.moviesGrid.y,
    focusX: 0,
    focusY: 0,
    title: 'Movies',
    noData: gettext('No results found.'),
    bufferSize: app.metrics.moviesGrid.cache,
    emptyLine: true,
    render: require('../renders/item.list'),
    className: 'moviesGrid',

    events: {
        'click:item': function ( event ) {
            var value = event.$item.value;

            if ( value ) {
                if ( (value.censored || (value.category && value.category.censored)) && !core.accessControl.state ) {
                    core.accessControl.request(function ( error ) {
                        if ( !error ) {
                            app.route(app.pages.info, {info: value, type: 'main'});
                        }
                    });
                } else {
                    app.route(app.pages.info, {info: value, type: 'main'});
                }
            }
        },

        focus: function () {
            if ( this.data.length ) {
                infoPanel.showMovie();
            } else {
                filtersList.focus();
            }

        },

        'focus:item': function ( event ) {
            clearTimeout(timers.info);
            if ( this.focusY > 0 ) {
                filtersList.hide();
            } else {
                filtersList.show();
            }
            timers.info = setTimeout(function () {
                if ( event.$curr ) {
                    if ( event.$curr.value ) {
                        infoPanel.fillMovie(event.$curr.value);
                    }
                }
            }, core.environment.onFocusDebounceTimeout);
        },

        overflow: function ( event ) {
            if ( event.direction === keys.up ) {
                filtersList.focus();
            }
        },

        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.f3:
                    toggleFavorite();
                    event.stop = true;
                    break;

                default:
                    Grid.prototype.defaultEvents.keydown.call(this, event);
                    break;
            }
        }
    }
});


leftLayout = new Layout({
    focusable: false,
    data: [searchLayout, filtersList, moviesGrid],
    className: 'mainPanel'
});


leftLayout.$node.appendChild(dom.tag('div', {className: 'shadow'}));
page.add(leftLayout);

page.add(infoPanel.layout);


//genre list selection modal
modalSelectGenre = new ModalCheckList({
    visible: false,
    title: gettext('Choose genres'),
    events: {
        'checked:change': function ( event ) {
            var titleLinks = filtersList.links.genres.title,
                title = '',
                value = '';

            event.checkedData.forEach(function ( item ) {
                title += ( title ? ', ' : '' ) + item.title;
                value += ( value ? ',' : '' ) + item.value;
            });

            requestConfig.offset = 0;
            requestConfig.limit = 0;
            if ( title ) {
                requestConfig.genreId = value;
                titleLinks.blured.innerText = title;
                titleLinks.focused.innerText = title;
            } else {
                requestConfig.genreId = '';
                titleLinks.blured.innerText = gettext('All genres');
                titleLinks.focused.innerText = gettext('All genres');
            }

            if ( !noEvents ) {
                moviesGrid.init({
                    getter: getMovies,
                    request: requestConfig
                });
            }
        },

        show: function () {
            this.focus();
        },
        hide: function () {
            filtersList.focus();
        }
    },
    list: {
        focusIndex: 0,
        size: app.metrics.modal.size,
        cycle: false,
        classIconActive: 'theme-icon theme-icon-ok',
        classIcon: 'theme-icon'
    }
});
page.add(modalSelectGenre);


//categories list selection modal
modalSelectYear = new ModalCheckList({
    visible: false,
    title: gettext('Choose years'),
    events: {
        'checked:change': function ( event ) {
            var titleLinks = filtersList.links.years.title,
                title = '',
                value = '',
                index = 0;

            event.checkedData.forEach(function ( item ) {
                title += ( title ? ', ' : '' ) + item.title;
                for ( index = item.value.start; index <= item.value.end; index++ ) {
                    value += ( value ? ',' : '' ) + index;
                }
            });

            requestConfig.offset = 0;
            requestConfig.limit = 0;
            if ( title ) {
                requestConfig.year = value;
                titleLinks.blured.innerText = title;
                titleLinks.focused.innerText = title;
            } else {
                requestConfig.year = '';
                titleLinks.blured.innerText = gettext('All years');
                titleLinks.focused.innerText = gettext('All years');
            }

            moviesGrid.init({
                getter: getMovies,
                request: requestConfig
            });
        },

        show: function () {
            this.focus();
        },
        hide: function () {
            filtersList.focus();
        }
    },
    list: {
        focusIndex: 0,
        size: app.metrics.modal.size,
        cycle: false,
        data: utils.initYears(),
        classIconActive: 'theme-icon theme-icon-ok',
        classIcon: 'theme-icon'
    }
});
page.add(modalSelectYear);


//sort list selection modal
modalSortFilm = new ModalMessage({
    visible: false,
    title: gettext('Sort by:'),
    events: {
        show: function () {
            this.children[0].focus();
        }
    },
    children: [
        sortList = new RadioList({
            focusIndex: 0,
            size: app.metrics.modal.size,
            classIconActive: 'theme-icon theme-icon-ok',
            classIcon: 'theme-icon',
            cycle: true,
            data: [
                {
                    state: true,
                    title: gettext('date'),
                    value: 'added'
                },
                {
                    state: false,
                    title: gettext('name'),
                    value: 'name'
                },
                {
                    state: false,
                    title: gettext('rating'),
                    value: 'rating'
                }
            ],
            events: {
                select: function ( item ) {
                    filtersList.links.sort.title.blured.innerText = gettext('Sort by') + ' ' + item.data.title;
                    filtersList.links.sort.title.focused.innerText = gettext('Sort by') + ' ' + item.data.title;
                    requestConfig.sortby = item.data.value;

                    moviesGrid.init({
                        getter: getMovies,
                        request: requestConfig
                    });
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    switch ( event.code ) {
                        case keys.back:
                            modalSortFilm.hide();
                            filtersList.focus();
                            event.stop = true;
                            break;
                    }
                }
            }
        })
    ]
});
page.add(modalSortFilm);


if ( DEVELOP ) {
    window.moviesGrid = moviesGrid;
    window.searchLayout = searchLayout;
    window.filtersList = filtersList;
    window.modalSelectYear = modalSelectYear;
    window.sortList = sortList;
    window.modalSortFilm = modalSortFilm;
    window.modalSelectGenre = modalSelectGenre;
}


/**
 * Init page.
 */
page.addListeners({
    show: function ( event ) {
        var config = {},
            item;

        if ( !event.data ) {
            return;
        }

        for ( item in event.data.query ) {
            if ( event.data.query[item] ) {
                config[item] = event.data.query[item];
            }
        }

        requestConfig = config;

        noEvents = true;
        modalSelectGenre.clearChecked(0);
        modalSelectYear.clearChecked(0);
        noEvents = false;

        requestConfig.offset = 0;
        requestConfig.limit = 0;
        moviesGrid.init({
            title: event.data.title,
            getter: getMovies,
            request: requestConfig
        });

        filtersList.show();
        filtersList.focus();

        sortList.resetData();
        filtersList.links.sort.title.blured.innerText = gettext('Sort by') + ' ' + sortList.checkedData.title;
        filtersList.links.sort.title.focused.innerText = gettext('Sort by') + ' ' + sortList.checkedData.title;

        searchLayout.$body.classList.remove('searchActive');
        searchLayout.links.$text.innerText = gettext('Search for movies, series and TV shows');
        searchLayout.links.$text.classList.add('noData');

        infoPanel.clearRating();
    },
    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.back:
                event.stop = true;
                app.route(app.pages.main);
                break;
        }
    }
});


page.once('show', function () {
    app.api.getGenres(function ( error, data ) {
        var result = [];

        if ( error ) {
            data = [];
        } else {
            data = data.data || [];
        }

        data.forEach(function ( item ) {
            result.push({
                state: false,
                title: item.name,
                value: item.ids.join(',')
            });
        });

        modalSelectGenre.list.setData({data: result, focusIndex: 0});
    });
});


app.addListener('change:favorite', function ( data ) {
    var video = data.video;

    if ( moviesGrid.$focusItem && video === moviesGrid.$focusItem.value ) {
        if ( video.favorite ) {
            infoPanel.$movie.classList.add('inFavorite');
        } else {
            infoPanel.$movie.classList.remove('inFavorite');
        }
    }
});


module.exports = page;
